function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classnames from 'classnames';
import { MessageBar as FabricMessageBar, MessageBarType } from '@fluentui/react';
import * as React from 'react'; // @ts-ignore TODO

import { CSSTransition } from 'react-transition-group';
import { Button as MessageBarButton } from '../Button/Button';
import { getClassNames } from './MessageBar.classNames';
import { t } from 'i18next';
/**
 * @deprecated Komponenten er erstattet av Alert fra "@skatteetaten/ds-status"
 *
 * visibleName MessageBar
 */

export class MessageBar extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      hideMessageBar: false,
      showMessage: true
    });

    _defineProperty(this, "setShowAlways", () => {
      this.setState({
        showMessage: true,
        hideMessageBar: false
      });
    });

    _defineProperty(this, "resetDurationMessage", () => {
      const {
        duration
      } = this.props;

      if (duration) {
        this.setState({
          showMessage: true
        });
      }

      setTimeout(() => {
        this.setState({
          hideMessageBar: true,
          showMessage: false
        });
      }, Number(duration) * 1000);
      this.setState({
        hideMessageBar: false
      });
    });
  }

  componentDidMount() {
    const {
      duration
    } = this.props;

    if (duration) {
      setTimeout(() => {
        this.setState({
          hideMessageBar: true
        });
      }, Number(duration) * 1000);
    }
  }

  render() {
    const {
      showMessage,
      hideMessageBar
    } = this.state;

    const _this$props = this.props,
          {
      children,
      actions,
      onClick,
      duration,
      type,
      onDismiss,
      dismissButtonAriaLabel,
      isMultiline,
      className,
      id,
      onRenderAfterDuration
    } = _this$props,
          props = _objectWithoutProperties(_this$props, ["children", "actions", "onClick", "duration", "type", "onDismiss", "dismissButtonAriaLabel", "isMultiline", "className", "id", "onRenderAfterDuration"]);

    const afterDurationComponent = onRenderAfterDuration && onRenderAfterDuration(this.resetDurationMessage, this.setShowAlways);
    return /*#__PURE__*/React.createElement("div", {
      id: id
    }, hideMessageBar && /*#__PURE__*/React.createElement("div", null, afterDurationComponent), /*#__PURE__*/React.createElement(CSSTransition, {
      in: showMessage && !hideMessageBar,
      classNames: "fade",
      timeout: 300,
      unmountOnExit: true
    },
    /*
    // @ts-ignore TODO */
    status => /*#__PURE__*/React.createElement(FabricMessageBar, _extends({}, props, {
      className: classnames(getClassNames(this.props), status, className),
      actions: actions,
      messageBarType: type,
      onDismiss: onDismiss,
      isMultiline: isMultiline,
      "aria-describedby": id,
      role: "status",
      dismissButtonAriaLabel: dismissButtonAriaLabel || t('common.close')
    }), children)));
  }

}

_defineProperty(MessageBar, "Type", MessageBarType);

_defineProperty(MessageBar, "Button", MessageBarButton);

_defineProperty(MessageBar, "defaultProps", {
  actions: undefined,
  isMultiline: true,
  onClick: undefined,
  size: 'default',
  type: MessageBar.Type.info
});